<template>
  <span style="text-align:left">
    <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
      <v-text-field
        v-bind:value="preLoad(value)"
        v-on:input="event => $emit('input', preUpdate(event))"
        required
        :rules="crud.evalrules(campo)"
        :hint="T(campo.cmp_dica)"
        persistent-hint
      ></v-text-field>
    </template>

    <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
      <span :class="{ 'text-xs-center': modo == 'list' }">{{
        displayvalue
      }}</span>
    </template>

    <template v-if="modo == 'filtro'">
      <v-text-field
        height="20"
        class="ma-0 pa-1"
        hide-details
        v-bind:value="preLoadFiltro(value)"
        v-on:input="event => $emit('input', preUpdateFiltro(event))"
      ></v-text-field>
    </template>
  </span>
</template>

<script>
export default {
  props: ["value", "campo", "crud", "row", "modo"],
  data() {
    return { loading: false };
  },
  computed: {
    displayvalue() {
      return this.displayValue();
    }
  },
  mounted() {
    // console.log('thiscrud',this.crud);
    if (this.crud) this.crud.addCampoRef(this.campo.cmp_coluna, this);
  },

  methods: {
    validationRule() {
      return null;
    },
    onEnter() {
      window.document.getElementById("botaoFiltarPadrao").click();
    },

    displayValue() {
      return this.computeContaVal(this.value);
    },

    computeContaVal(val) {
      if (this.crud.canExecuteFunction(this.campo.cmp_conta)) {
        return this.crud.executeFunctionSync(this.campo.cmp_conta, [
          val,
          this.row
        ]);
      } else {
        return val;
      }
    },

    preLoad(myval) {
      return myval;
    },
    preUpdate(myval) {
      return myval;
    },
    preLoadFiltro(myval) {
      return myval;
    },
    preUpdateFiltro(myval) {
      return myval;
    },

    async callLocalAction(actionName, params, aplicar_auto = false) {
      this.loading = true;

      let clone = _.clone(this.crud.localsession[this.crud.sid]);
      delete clone["filtro"];

      clone.master = _.pickBy(this.crud.form, (v, k) => !_.startsWith(k, "_"));

      let credentials = {
        module: this.crud.module,
        localsession: clone,
        column: this.campo.cmp_coluna,
        action: "actionComponentUpdate",
        actionName: actionName,
        params
      };
      try {
        let result = await Api().post("admin/crud/async", credentials);

        if (result.data.output !== null) {
          if (aplicar_auto)
            this.row._extra[this.campo.cmp_coluna] = result.data.output;
          this.$forceUpdate();
          this.loading = false;
          return result.data.output;
        }
      } catch (e) {
        this.loading = false;
      }
      return null;
    },

    getComponentParam(prop) {
      if (this.campo.param == null || this.campo.param.trim() == "")
        return null;
      let linhas = this.campo.param
        .trim()
        .split("\n")
        .map(v =>
          v
            .trim()
            .split("=")
            .map(f => f.trim())
        )
        .filter(x => x[0] == prop);
      if (linhas.length > 0) {
        return linhas[0][1];
      }
      return null;
    }
  }
};
</script>

<style scoped></style>
